export default "__VITE_ASSET__Dy$oym2N__"